/**
 * Returns the first non-null/undefined value, or the fallback if all are null/undefined
 */
export function coalesce<T>(value: T | null | undefined, fallback: T): T {
  return value ?? fallback;
}
